module.exports = __webpack_public_path__ + "static/img/long-line.57a4a8ed.png";